export const VERIFY_USER_ACTIONS = {
    ADD_EMAIL_ADDRESS: "ADD_EMAIL_ADDRESS",
    SAVE_CONVERSATION: "SAVE_CONVERSATION",
};
